export default __webpack_public_path__ + "assets/webgl/sh.340c0654.bin";